import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  forgetUnavailablePackChoice,
  productParameters,
  pledgeProductHasPacks,
  withSequentialSuffixes,
} from '../../../../pledge-pack-choice';


@UntilDestroy()
@Component({
  selector: 'versement-investment-allocation',
  templateUrl: './versement-investment-allocation.component.html',
  styleUrls: ['./versement-investment-allocation.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
  standalone: false,
})
export class VersementInvestmentAllocationComponent implements OnInit {
  freeOption: FormControlOption = {
    label: 'Choix libre',
    value: 'FREE',
    suffix: 'A',
    svg: 'free-choice.svg',
  };
  packOption: FormControlOption = {
    label: 'Allocation type',
    value: 'PACK',
    suffix: 'B',
    svg: 'package-choice.svg',
  };
  currentOption: FormControlOption = {
    label: "Garder l'allocation actuelle",
    value: 'CURRENT',
    suffix: 'C',
    svg: 'combo-chart.svg',
  };
  options: FormControlOption[] = [this.freeOption];

  private hasPacks = false;
  private hasCurrentAllocation = false;

  constructor(
    private simulationDao: SimulationDao,
    private subscriptionFacade: SubscriptionFacadeService,
    private controlContainer: ControlContainer,
  ) {}

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const currentSupports =
      pledge?.products?.[0]?.parameters?.currentSupportRepartition
        ?.supportRepartition || [];
    this.hasCurrentAllocation = currentSupports.some(
      line => !!line?.isin && Number(line?.amount) > 0,
    );
    this.buildOptions();

    pledgeProductHasPacks(this.simulationDao, pledge)
      .pipe(untilDestroyed(this))
      .subscribe(hasPacks => {
        if (hasPacks) {
          this.hasPacks = true;
          this.buildOptions();
        } else if (hasPacks === false) {
          forgetUnavailablePackChoice(
            this.controlContainer.control,
            'versementDistribution',
            this.subscriptionFacade,
            productParameters,
          );
        }
      });
  }

  private buildOptions() {
    const options = [this.freeOption];
    if (this.hasPacks) {
      options.push(this.packOption);
    }
    if (this.hasCurrentAllocation) {
      options.push(this.currentOption);
    }

    this.options = withSequentialSuffixes(options);
  }
}
